// @ts-nocheck

import CommonApi from './../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
const convertDataToServer = workingHourSelfPrice => ({
  ...workingHourSelfPrice,
  price: convertFromRubToKop(workingHourSelfPrice.price)
});
const convertDataFromServer = workingHourSelfPrice => ({
  ...workingHourSelfPrice,
  price: convertFromKopToRub(workingHourSelfPrice.price)
});
const workingHourSelfPrice = new CommonApi('workingHourSelfPrice', 'Стоимость нормо-часа хоз. способом', convertDataToServer, convertDataFromServer);
export default {
  ...workingHourSelfPrice
};
